const cloud = {
    general: {
        onboarding: 'Вводный курс',
    },
    create_tenant: {
        page_title: 'Создать арендатора',
        title: 'Создайте вашего первого арендатора',
        description: 'Арендатор – это изолированная среда, где вы можете управлять пользовательскими идентификаторами, приложениями и всеми другими ресурсами Logto.',
        invite_collaborators: 'Пригласите ваших сотрудников по электронной почте',
    },
    social_callback: {
        title: 'Вход выполнен успешно',
        description: 'Вы успешно вошли, используя свою учетную запись в социальной сети. Чтобы обеспечить безпроблемную интеграцию и доступ ко всем функциям Logto, рекомендуем настроить свой собственный социальный коннектор.',
        notice: 'Пожалуйста, избегайте использования демонстрационного коннектора в производственных целях. После завершения тестирования, пожалуйста, удалите демонстрационный коннектор и настройте собственный коннектор с вашими учетными данными.',
    },
    tenant: {
        create_tenant: 'Создать арендатора',
    },
};
export default Object.freeze(cloud);
